"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SHOW_MENU = exports.SHOW_MENU = "SHOW_MENU";
var CHANGE_BOTTOM_NAVIGATION_INDEX = exports.CHANGE_BOTTOM_NAVIGATION_INDEX = "CHANGE_BOTTOM_NAVIGATION_INDEX";
var SHOW_DIALOG = exports.SHOW_DIALOG = "SHOW_DIALOG";
var SHOW_TOAST = exports.SHOW_TOAST = "SHOW_TOAST";
var SET_LOGO = exports.SET_LOGO = "SET_LOGO";
var SET_APP_NAME = exports.SET_APP_NAME = "SET_APP_NAME";
var SET_ROUTE = exports.SET_ROUTE = "SET_ROUTE";
var ADD_LOCALIZATION = exports.ADD_LOCALIZATION = "ADD_LOCALIZATION";
var UPDATE_LOCALIZATION = exports.UPDATE_LOCALIZATION = "UPDATE_LOCALIZATION";
var SET_USER_INFO = exports.SET_USER_INFO = "SET_USER_INFO";
var SET_USER_CURRENT_LOCATION = exports.SET_USER_CURRENT_LOCATION = "SET_USER_CURRENT_LOCATION";
var ADD_BREADCRUMB_ITEM = exports.ADD_BREADCRUMB_ITEM = "ADD_BREADCRUMBS_ITEM";
var REMOVE_BREADCRUMB_ITEM = exports.REMOVE_BREADCRUMB_ITEM = "REMOVE_BREADCRUMB_ITEM";
var FETCH_ACTIONMENU = exports.FETCH_ACTIONMENU = "FETCH_ACTIONMENU";
var FETCH_DEVICEINFO = exports.FETCH_DEVICEINFO = "FETCH_DEVICEINFO";
var FETCH_UI_COMMON_CONFIG = exports.FETCH_UI_COMMON_CONFIG = "FETCH_UI_COMMON_CONFIG";
var FETCH_UI_COMMON_CONSTANTS = exports.FETCH_UI_COMMON_CONSTANTS = "FETCH_UI_COMMON_CONSTANTS";
var UPDATE_ACTIVE_ROUTE_PATH = exports.UPDATE_ACTIVE_ROUTE_PATH = "UPDATE_ACTIVE_ROUTE_PATH";
var SET_PREVIOUS_ROUTE = exports.SET_PREVIOUS_ROUTE = "SET_PREVIOUS_ROUTE";
var GET_NOTIFICATION_COUNT = exports.GET_NOTIFICATION_COUNT = "GET_NOTIFICATION_COUNT";
var GET_NOTIFICATIONS_COMPLETE = exports.GET_NOTIFICATIONS_COMPLETE = "GET_NOTIFICATIONS_COMPLETE";
var GET_NOTIFICATIONS_PENDING = exports.GET_NOTIFICATIONS_PENDING = "GET_NOTIFICATIONS_PENDING";
var GET_NOTIFICATIONS_ERROR = exports.GET_NOTIFICATIONS_ERROR = "GET_NOTIFICATIONS_ERROR";
var USER_ACTIOM_ERROR = exports.USER_ACTIOM_ERROR = "USER_ACTIOM_ERROR";
var AUTHENTICATION_FAILED = exports.AUTHENTICATION_FAILED = "AUTHENTICATION_FAILED";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/redux/app/actionTypes.js
// module id = 369
// module chunks = 1143